module.exports = __webpack_public_path__ + "static/img/8.5613a09a.png";